(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vapora-sinkflow"] && !Shopify.designMode) return;
  try {
    
function setupSinkFlow(root){if(root.dataset.ready)return;root.dataset.ready='true';const timer=root.querySelector('[data-countdown]');if(timer){const deadline=Date.parse(timer.dataset.deadline);const clock=timer.querySelector('[data-clock]');const tick=()=>{const left=deadline-Date.now();if(left<=0){timer.dataset.expired='true';return;}const days=Math.floor(left/86400000);const hours=Math.floor((left%86400000)/3600000);const minutes=Math.floor((left%3600000)/60000);const seconds=Math.floor((left%60000)/1000);clock.textContent=`${days}d ${String(hours).padStart(2,'0')}:${String(minutes).padStart(2,'0')}:${String(seconds).padStart(2,'0')}`;};tick();window.setInterval(tick,1000);}const slides=root.querySelector('.sf-slides');const count=slides.children.length;const counter=root.querySelector('.sf-counter');const labels=JSON.parse(root.querySelector('[data-sf-labels]').textContent);const update=()=>counter.textContent=`${Math.round(slides.scrollLeft/slides.clientWidth)+1} / ${count}`;root.querySelector('[data-gallery-prev]').addEventListener('click',()=>slides.scrollBy({left:-slides.clientWidth}));root.querySelector('[data-gallery-next]').addEventListener('click',()=>slides.scrollBy({left:slides.clientWidth}));slides.addEventListener('scroll',update,{passive:true});update();root.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',()=>{root.querySelector('[data-price]').textContent=input.dataset.price;const button=root.querySelector('[data-add]');button.disabled=input.dataset.available!=='true';button.querySelector('[data-add-label]').textContent=button.disabled?labels.sold:labels.add;const hero=slides.querySelector('.sf-slide img');if(hero&&input.dataset.hero){hero.removeAttribute('srcset');hero.src=input.dataset.hero;hero.alt=input.dataset.heroAlt;slides.scrollTo({left:0,behavior:'instant'});update();}const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);}));}
document.querySelectorAll('.sf').forEach(setupSinkFlow);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.sf').forEach(setupSinkFlow));
  } catch(e) { console.error(e); }
})();
})();
